import React, { useContext, useEffect, useRef } from 'react';
import { ChatBody, ChatControls, ChatHeader, ChatHistory } from '.';
import { MessagingContext } from '../../../services';
import { Spinner } from '../../base';
import { SidePanel } from '../side-panel';
import * as S from './chat-panel.styles';

export interface IChatPanelProps {
    className?: string;
    hideDone?: boolean;
    hideNote?: boolean;
    onBack?: () => void;
}

export const ChatPanel: React.FunctionComponent<IChatPanelProps> = (props: IChatPanelProps): React.ReactElement => {
    const context = useContext(MessagingContext);
    const scrollRef = useRef<HTMLDivElement | null>(null);

    const { className, hideDone, hideNote, onBack } = props;
    const { comments, isDetailLoading, message } = context;
    // Show loading only when we don't have a message yet - allows progressive rendering
    const loading = isDetailLoading && !message;

    const scrollToTop = (): void => {
        if (scrollRef && scrollRef.current) {
            scrollRef.current.scrollTo(0, 0);
        }
    };
    const scrollToBottom = (): void => {
        if (scrollRef && scrollRef.current) {
            const { current } = scrollRef;
            current.scrollTo(0, current.scrollHeight);
        }
    };

    return (
        <SidePanel className={className}>
            <ChatHeader onBack={onBack} />
            <S.Scrollable ref={scrollRef}>
                {loading && <Spinner />}
                {!loading && (
                    <>
                        <ChatBody hideNote={hideNote} />
                        <ChatHistory hideNote={hideNote} />
                    </>
                )}
            </S.Scrollable>
            {!loading && <ChatControls hideDone={hideDone} hideNote={hideNote} />}
        </SidePanel>
    );
};
